__turbopack_context__.v({
  "card": "Card-module-scss-module__P4FWGG__card",
  "chip": "Card-module-scss-module__P4FWGG__chip",
  "content": "Card-module-scss-module__P4FWGG__content",
  "description": "Card-module-scss-module__P4FWGG__description",
  "image": "Card-module-scss-module__P4FWGG__image",
  "imageWrapper": "Card-module-scss-module__P4FWGG__imageWrapper",
  "link": "Card-module-scss-module__P4FWGG__link",
  "readMore": "Card-module-scss-module__P4FWGG__readMore",
  "readMoreIcon": "Card-module-scss-module__P4FWGG__readMoreIcon",
  "readMoreWrapper": "Card-module-scss-module__P4FWGG__readMoreWrapper",
  "title": "Card-module-scss-module__P4FWGG__title",
  "titleWrapper": "Card-module-scss-module__P4FWGG__titleWrapper",
});
